import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatWidget from "./pages/ChatWidget";
import WidgetIcon from "./pages/WidgetIcon";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<ChatWidget />} />
          <Route path="/icon" element={<WidgetIcon />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
